import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, UiBox, UiButton, UiImage, UiQuestionnaireLayout, UiSimpleGrid, UiText} from '~/components/elements';
import TextModal from '~/components/modals/TextModal';
import {ScrollToBottomButton} from '~/components/shared/ScrollToBottomButton';
import {
  BIRTH_CONTROL_REQUEST_KEYS,
  EMERGENCY_CONTRACEPTION_KEYS,
  LAST_PROTECT_INTERCOURSE,
} from '~/constants/medical-questionnaires';
import {useInput, useNotification} from '~/hooks';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire5Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const [isShowSorryModal, setIsShowSorryModal] = useState(false);
  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[BIRTH_CONTROL_REQUEST_KEYS.STATEMENT_BEST_APPLIES]?.data,
  );
  const birthControlUsedAnswer = useSelector(
    (state: RootState) =>
      state.questionnaires?.collectData[BIRTH_CONTROL_REQUEST_KEYS.BRAND_USED]?.data?.selectedOption,
  );

  const notUsedBCbefore = birthControlUsedAnswer === 'NO';

  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === BIRTH_CONTROL_REQUEST_KEYS.STATEMENT_BEST_APPLIES);

  const options = notUsedBCbefore ? questionnaire?.optionsNo : questionnaire?.options;

  const {inputs, setInputs} = useInput({selectedOption: currentAnswer?.selectedOption || ''});

  const onClickOption = (answer: {value: string | number; label: string}) => {
    const {value} = answer;
    setInputs({selectedOption: value});
  };

  const onClickSubmit = async () => {
    dispatch(
      setQuestionnaireAnswer({
        key: BIRTH_CONTROL_REQUEST_KEYS.STATEMENT_BEST_APPLIES,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    dispatch(setNextQuestionnaire({value: BIRTH_CONTROL_REQUEST_KEYS.MEDICAL_HISTORY}));
  };

  return (
    <>
      <UiQuestionnaireLayout
        backIcon
        handleOnNext={onClickSubmit}
        disableNext={!inputs.selectedOption}
        actions={questionnaire?.actions}
        checkoutStep={questionnaire?.checkoutStep}
      >
        <Col alignItems="center" textAlign="center">
          <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.medium} />
          <UiText fontSize="xl" fontWeight="bold" mt={spacing.large}>
            {questionnaire?.questions?.default}
          </UiText>
          <UiBox mt={spacing.medium} w="100%">
            <UiSimpleGrid columns={1} spacing={5}>
              {options?.map(value => (
                <ScrollToBottomButton
                  key={`${value.label}-${value.value}`}
                  title={value.label}
                  variant={inputs.selectedOption === value.value ? 'solid' : 'toggle'}
                  onClick={() => onClickOption(value)}
                  height="64px"
                />
              ))}
            </UiSimpleGrid>
          </UiBox>
        </Col>
      </UiQuestionnaireLayout>
    </>
  );
};

export default Questionnaire5Screen;
